import { Component, Suspense } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import './scss/style.scss'
import { getJWTfromCookie } from './utils/handleCookie.js'
import { QueryClient, QueryClientProvider } from 'react-query'
import './index.css'
import 'antd/dist/antd.less'
import { lazy } from 'react'
import Loader from './components/shared/Loader'
import toast, { Toaster } from 'react-hot-toast'

// Force Title Case for all toast messages
const toTitleCase = (str) => {
  if (typeof str !== 'string') return str;
  return str.toLowerCase().split(' ').map(function(word) {
    return (word.charAt(0).toUpperCase() + word.slice(1));
  }).join(' ');
}

const originalError = toast.error;
toast.error = (msg, options) => {
  return originalError(typeof msg === 'string' ? toTitleCase(msg) : msg, options);
}

const originalSuccess = toast.success;
toast.success = (msg, options) => {
  return originalSuccess(typeof msg === 'string' ? toTitleCase(msg) : msg, options);
}

const originalCustom = toast.custom;
if (originalCustom) {
  toast.custom = (msg, options) => {
    return originalCustom(typeof msg === 'string' ? toTitleCase(msg) : msg, options);
  }
}
const Login = lazy(() => import('./views/pages/login/newLogin.jsx'))
const VerificationOtp = lazy(() => import('./views/dashboard/VerificationsOtp'))
const Register = lazy(() => import('./views/pages/Register/Register.jsx'))
const DefaultLayout = lazy(() => import('./layout/DefaultLayout'))


// Pages
const ProtectedRoute = ({ component: Component, ...rest }) => <Route {...rest} render={(props) => (getJWTfromCookie() ? <Component {...props} /> : <Redirect to={{ pathname: '/login' }} />)} />
const PublicRoute = ({ component: Component, ...rest }) => <Route {...rest} render={(props) => (getJWTfromCookie() ? <Redirect to={{ pathname: '/home' }} /> : <Component {...props} />)} />
const queryClient = new QueryClient()
import { registerLicense} from '@syncfusion/ej2-base';
import PrivacyPolicy from './views/dashboard/privacy'
import Contactus from './views/dashboard/Contactus'


registerLicense(
  'Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXtedHRXRWBcUUB3V0FWYUA='
);

window.NavigationDetails = {}
window.DiagnosList = []
window.PatientData = []
window.ActiveSelection = true
import axios from 'axios'
import { BASE_URL, LOGIN } from './constants/api.config'
import { useEffect } from 'react'

const AuthStatusPoller = () => {
  useEffect(() => {
    const checkStatus = async () => {
      const userCredsStr = localStorage.getItem('userLoginWithCredentials')
      const jwtToken = localStorage.getItem('jwt_token')
      if (!userCredsStr || !jwtToken) return

      try {
        const creds = JSON.parse(userCredsStr)
        const response = await axios.post(`${BASE_URL}/${LOGIN}`, creds, {
          headers: { 'Content-Type': 'application/json' }
        })

        const data = response.data
        if (data?.d && data.d["ErrCode"] >= 1) {
          const result = data.d
          if (result && result.Users && result.Users.length > 0) {
            const user = result.Users[0]
            let isDeactivated = false

            if (
              user.Status === 'Deactive' || user.status === 'Deactive' ||
              user.Status === 'Inactive' || user.status === 'Inactive' ||
              user.ProviderStatus === 'Deactive' || user.ProviderStatus === 'Inactive' ||
              user.ProviderStatus?.toLowerCase() === 'inactive' ||
              user.Status?.toLowerCase() === 'inactive'
            ) {
              isDeactivated = true
            } else if (user.Extra || user.extraData || user.ExtraData) {
              try {
                const rawExtra = user.ExtraData || user.Extra || user.extraData;
                const extraData = typeof rawExtra === 'string' ? JSON.parse(rawExtra) : rawExtra;
                if (
                  extraData.status === 'Deactive' || extraData.status === 'Inactive' ||
                  extraData.status?.toLowerCase() === 'inactive' ||
                  extraData.ProviderStatus === 'Deactive' || extraData.ProviderStatus === 'Inactive' ||
                  extraData.ProviderStatus?.toLowerCase() === 'inactive'
                ) {
                  isDeactivated = true
                }
              } catch (e) { }
            }

            if (isDeactivated) {
              localStorage.removeItem('jwt_token')
              localStorage.removeItem('user')
              localStorage.removeItem('userLoginWithCredentials')
              window.location.href = '/login'
            }
          }
        } else if (data?.d && data.d["ErrCode"] < 1) {
            localStorage.removeItem('jwt_token')
            localStorage.removeItem('user')
            localStorage.removeItem('userLoginWithCredentials')
            window.location.href = '/login'
        }
      } catch (error) {
        // Ignore network errors
      }
    }

    const intervalId = setInterval(checkStatus, 24 * 60 * 60 * 1000)
    return () => clearInterval(intervalId)
  }, [])

  return null
}

class App extends Component {

  render() {
    return (
      <QueryClientProvider client={queryClient}>
        <AuthStatusPoller />
        <Router>
          <Toaster 
            toastOptions={{
              className: 'global-toast',
              style: {
                textTransform: 'capitalize',
              },
            }}
          />
          <Suspense fallback={<Loader />}>
            <Switch>
              <PublicRoute exact path="/" name="Homepage" component={() => <Login />} />
              <PublicRoute exact path="/contact-us" name="contact-us" component={() => <Contactus />} />
              <PublicRoute exact path="/login" name="Login Page" component={() => <Login />} />
              <PublicRoute exact path="/privacy-policy" name="Login Page" component={() => <PrivacyPolicy />} />
              <ProtectedRoute path="/home" component={() => <DefaultLayout />} />
              <PublicRoute exact path="/login" name="Login Page" component={() => <Login />} />
              <ProtectedRoute exact path="/verification" name="Otp Verification" component={() => <VerificationOtp />} />
              <ProtectedRoute exact path="/register" name="Register page" component={() => <Register />} />
              <ProtectedRoute path="/dashboard" component={() => <DefaultLayout />} />
              <ProtectedRoute path="/datawarehouse" component={() => <DefaultLayout />} />
              <ProtectedRoute path="/details" component={() => <DefaultLayout />} />
              <ProtectedRoute path="/questions" component={() => <DefaultLayout />} />
              <ProtectedRoute path="/childTable" component={() => <DefaultLayout />} />
            </Switch>
          </Suspense>

        </Router>
      </QueryClientProvider>
    )
  }
}

export default App
